module.exports = __webpack_public_path__ + "static/img/purui.f8cf2f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/purui.jpg
// module id = 2iMc
// module chunks = 1